<template>
  <div v-if="isDdxVisible" class="ddx-widget-container">
    <div class="card" :class="{ showform: isOpened }">
      <div class="ddx-widget ddx-form">
        <div class="widget-content">
          <div class="ddx-form__body-txt">
            <div class="ddx-form__content">
              <div class="ddx-form__title">
                <div class="ddx-form_title is-2" v-html="title"></div>
                <div class="ddx-form__description" v-html="description"></div>
              </div>
              <form @submit.prevent="submitForm()" novalidate autocomplete="off">
                <div v-if="fieldFirstName.label != ''" class="fieldset">
                  <field-input
                    v-model="form.firstName"
                    :v="$v.form.firstName"
                    :field="fieldFirstName"
                  />
                </div>
                <div v-if="fieldLastName.label != ''" class="fieldset">
                  <field-input
                    v-model="form.lastName"
                    :v="$v.form.lastName"
                    :field="fieldLastName"
                  />
                </div>
                <div v-if="fieldEmail.label != ''" class="fieldset">
                  <field-input v-model="form.email" :v="$v.form.email" :field="fieldEmail" />
                </div>
                 <div class="fieldset" v-if="fieldPhoneNumber.label != ''">
                  <field-input v-model="form.phone"
                              :v="$v.form.phone"
                              :field="fieldPhoneNumber" />
                </div>
                
               <div class="fieldset" v-if="fieldSkinConcern.label != ''">
                  <div class="select-custom__btn">
                    <label for="skinConcern">{{fieldSkinConcern.label}}</label>

                    <select
                      id="skinConcern"
                      name="skinConcern"
                      v-model="form.skinConcern"
                    >
                      <option
                        v-for="(item, index) in fieldSkinConcern.listValue"
                        :key="index"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                    <svg width="16" height="8" aria-hidden="true"><path fill-rule="nonzero" d="M14.675.62l.65.76L8 7.659.675 1.379l.65-.759L8 6.341z"></path></svg>
                  </div>                 
                </div>
            
                <template>
                  <div
                    class="custom-form__checkbox-group"
                    v-for="(item, index) in fieldCheckboxes"
                    :key="index"
                  >
                    <div>
                      <field-checkbox
                        v-if="item.required"
                        :value="form.gdpr[`checkbox-${item.gdprId}`]"
                        v-model="form.gdpr[`checkbox-${item.gdprId}`]"
                        :v="$v.form.gdpr[`checkbox-${item.gdprId}`]"
                        :field="item"
                      />
                      <field-checkbox
                        v-else
                        :value="form.gdpr[`checkbox-${item.gdprId}`]"
                        v-model="form.gdpr[`checkbox-${item.gdprId}`]"
                        :field="item"
                      />
                    </div>
                  </div>
                </template>
                <div class="custom-form__actions">
                  <div>
                    <button type="submit" class="cta cta--light">
                      <span class="btn__wrapper">{{ submitBtnText }}</span>
                    </button>
                  </div>
                </div>
              </form>

              <div class="success__section">
                <svg
                  class="success__icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="67"
                  height="66"
                  viewBox="0 0 67 66"
                  fill="none"
                >
                  <path
                    d="M33.5 1C37.6577 1 41.5689 1.73941 45.2422 3.21289L45.9736 3.5166C49.6334 5.09581 52.8379 7.19987 55.5947 9.82715L56.1406 10.3594C59.0176 13.2363 61.2989 16.6226 62.9834 20.5264C64.6595 24.4107 65.5 28.5652 65.5 33C65.5 37.1577 64.7606 41.0689 63.2871 44.7422L62.9834 45.4736C61.4042 49.1334 59.3001 52.3379 56.6729 55.0947L56.1406 55.6406C53.4434 58.3379 50.2985 60.511 46.6992 62.1602L45.9736 62.4834C42.0893 64.1595 37.9347 65 33.5 65C29.0652 65 24.9107 64.1595 21.0264 62.4834C17.3666 60.9042 14.1621 58.8001 11.4053 56.1729L10.8594 55.6406C8.16212 52.9434 5.98902 49.7985 4.33984 46.1992L4.0166 45.4736C2.34053 41.5893 1.5 37.4347 1.5 33C1.5 28.8423 2.23941 24.9311 3.71289 21.2578L4.0166 20.5264C5.59581 16.8666 7.69987 13.6621 10.3271 10.9053L10.8594 10.3594C13.5566 7.66212 16.7015 5.48902 20.3008 3.83984L21.0264 3.5166C24.9107 1.84053 29.0652 1 33.5 1ZM33.5 5.59961C26.1089 5.59961 19.7791 8.09503 14.5664 13.0752L14.0654 13.5654C8.75897 18.8719 6.09961 25.3704 6.09961 33C6.09961 40.3911 8.59503 46.7209 13.5752 51.9336L14.0654 52.4346C19.3719 57.741 25.8704 60.4004 33.5 60.4004C40.8911 60.4004 47.2209 57.905 52.4336 52.9248L52.9346 52.4346C58.241 47.1281 60.9004 40.6296 60.9004 33C60.9004 25.6089 58.405 19.2791 53.4248 14.0664L52.9346 13.5654C47.6281 8.25897 41.1296 5.59961 33.5 5.59961ZM50.7305 24.9141L28.8799 46.7656L16.2686 34.1543L19.4746 30.9492L28.8799 40.3545L29.5869 39.6475L47.5244 21.709L50.7305 24.9141Z"
                    fill="#31C498"
                    stroke="white"
                    stroke-width="2"
                  />
                </svg>
                <p class="success__content">{{successMessage}}</p>
                <button type="submit" class="cta cta--light" @click="toggleOpen(),showForm()">
                      <span class="btn__wrapper" v-html="successCtaText"/> 
                    </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ddx-button" id="ddx-button">
      <div class="ddx-form__container">
        <div class="ddx-form__bg">
          <div class="container-ddx" :class="{ 'is-opened': isOpened }">
            <div class="floating-button" @click="toggleOpen">
              <img :src="imageUrl" class="icon ddx" />
              <svg class="icon close" viewBox="0 0 512 512">
                <path
                  d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                ></path>
              </svg>
            </div>
            <div class="ddx-form__label">{{ddxLabel}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { email, helpers, minLength, required, maxLength, sameAs } from 'vuelidate/lib/validators';
import FieldInput from '@Feature/CustomForms/fields/FieldInput/code/Scripts/components/field-input.vue';
import { validationMixin } from 'vuelidate';
import FieldCheckbox from '@Feature/CustomForms/fields/FieldCheckbox/code/Scripts/components/field-checkbox.vue';
import { postData } from '@Foundation/services';
const alphaExtended = helpers.regex('alphaExtended', /^[\w\D][^\u0021-\u002D\u003A-\u0040]*$/);

export default {
  name: 'DdxWidget',
  components: { FieldInput, FieldCheckbox },
  mixins: [validationMixin],
  props: {
    fieldEmail: { type: Object, required: true, default: {} },
    srcset: {
      type: [Object, String],
      required: false,
      default: undefined,
    },
    fieldFirstName: { type: Object, required: true, default: () => ({}),},
    fieldLastName: { type: Object, required: true,  default: () => ({}), },
    imageUrl: { type: String, default: '' },
    ctaClass: { type: String, default: 'btn btn--black' },
    submitBtnText: { type: String, default: 'Submit' },
    fieldCheckboxes: { type: Array, required: true, default: [] },
    apiUrl: { type: String, required: true, default: '' },
    title: { type: String, required: true, default: '' },
    ddxLabel: { type: String, required: true, default: '' },
    description: { type: String, required: true, default: '' },
    successMessage: { type: String, required: true, default: '' },
    successCtaText: {type: String, default: 'Done' },
    validationMsg: { type: Object,  default: () => ({}), },
    disableCheckbox: { type: Boolean, required: true, default: false },
    formSubmitTagging: { type: Object, required: true, default: () => ({}),},
    formOpenTagging: { type: Object, required: true, default: () => ({}),},
    fieldPhoneNumber: { type: Object, required: true, default: undefined },
    fieldSkinConcern: { type: Array, required: true, default: []},

  },

  data() {
    return {
      isDdxVisible: false,
      selectedSkinConcern: this.fieldSkinConcern.listValue[0].value ,
      isOpened: false,
      observer: null, // Store MutationObserver
      form: {
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        gdpr: {},
        error: false
      },
      validateDate: true,
      validationSettings: {
        form: {
          firstName: {
            alphaExtended,
          },
          lastName: {
            alphaExtended,
          },
          email: {
            email,
            required,
          },
          phone: {},
          gdpr: {},
        },
      },
      productInfo: {},
      formEle: null,
      successContainer: null,
    };
  },
  computed: {
    vulidateSettings: {
      get() {
        // GDPR checkboxes
        if (!this.disableCheckbox) {
          for (let index = 0; index < this.fieldCheckboxes.length; index++) {
            if (this.fieldCheckboxes[index].required) {
              this.$set(
                this.validationSettings.form.gdpr,
                `checkbox-${this.fieldCheckboxes[index].gdprId}`,
                {
                  required,
                  sameAs: sameAs(() => true),
                }
              );
            }
          }
        }
        /* istanbul ignore else */
        if (this.fieldEmail.required) {
          this.validationSettings.form.email = { email, required };
        }
        if(this.fieldPhoneNumber.required) {
          this.validationSettings.form.phone = {required};
        }
        if(this.fieldPhoneNumber.regExp !== '') {
          this.validationSettings.form.phone.phone= helpers.regex('regexpval', new RegExp(this.fieldPhoneNumber.regExp ));
        }
        if (this.fieldFirstName.required) {
          this.validationSettings.form.firstName = { required, alphaExtended };
        }
        if (this.fieldLastName.required) {
          this.validationSettings.form.lastName = { required, alphaExtended };
        }
        return this.validationSettings.form;
      },
    },
  },
  validations() {
    return {
      form: this.vulidateSettings,
    };
  },
  created() {
    this.setCheckboxesToVueData();
  },
  mounted() {   
    
    window.eventBus.$on('mikmakOpened', (productData) => {      
      this.productInfo = productData;
      this.isDdxVisible = true;  
      if (this.isOpened) {
        this.toggleOpen();        
      }
      setTimeout(() => {
      this.formEle = document.querySelector('form');
      this.successContainer = document.querySelector('.success__section');
      },50);
      const ddxContainer = document.querySelector('.ddx-widget-container');
      const variantPopup = document.querySelector('.variantPopup_active');
      if (variantPopup) {
        if (ddxContainer) {
          variantPopup.style.zIndex = 'unset';
        } else {
          variantPopup.style.removeProperty('z-index');
        }
      }            
    });
    window.eventBus.$on('mikmakClosed', () => {
      this.resetForm();   
      this.isDdxVisible = false;
    });
  },

  methods: {
    toggleOpen() {
      this.isOpened = !this.isOpened;
      if (this.isOpened) {
        window.eventBus.$emit('clearError', false);   
        this.taggingRegistration();
      }
      this.resetForm();
    },
     objectMap(object, mapFn) {
        return Object.keys(object).reduce(function (result, key) {
          result[key] = mapFn(object[key], key);
          return result;
        }, {});
      },
    setCheckboxesToVueData() {
      this.fieldCheckboxes.forEach((item) => {
        this.$set(this.form.gdpr, `checkbox-${item.gdprId}`, item.value);
      });
    },
    resetForm() {
      this.form = {
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        gdpr: {},
        skinConcern: this.fieldSkinConcern.listValue?.[0] ,
      };
    },
    submitForm() {
      this.validateDate = false;
      window.eventBus.$emit('clearError', true);
      this.$v.form.$touch();       
      this.$nextTick(() => {
        this.validateDate = true;
        
        setTimeout(() => {
          /* istanbul ignore next */

          if (this.$v.form.$pending || this.$v.form.$error) {
            return;
          } else {
            const gdpr = this.fieldCheckboxes.map((item, index) => {
              return {
                gdrpSettingItemId: this.fieldCheckboxes[index].gdprId,
                isSelected: this.form.gdpr[`checkbox-${item.gdprId}`],
              };
            });
            const serializedForm = this.objectMap(this.form, (value, key) => {
                if (typeof value === 'object' ) {
                  const checkedValues = [];
                  for (const key in value) {
                    if (value.hasOwnProperty(key)) {
                      value[key] && checkedValues.push(key);
                    }
                  }
                  return checkedValues;
                } else {
                  return value;
                }
              });
            postData(`${window.location.origin}/${this.apiUrl}`, {
              ...serializedForm,
              gdpr,
              skinConcern: document.getElementById('skinConcern') ? document.getElementById('skinConcern').value : '',
            })
              .then((response) => {
                if (this.formEle) this.formEle.style.display = 'none';
                this.taggingDdx();
                if (this.successContainer) this.successContainer.style.display = 'flex';
              })
              .catch(() => {
                console.error('Request failed');
              });
          }
        }, 200);
      });
    },
    taggingRegistration() {
      if(this.formOpenTagging){
        window.dataLayer.push({
        event: 'uaevent',
        ecommerce: 'undefined',        
        event_name: this.formOpenTagging.event_name,
        eventCategory: this.formOpenTagging.eventCategory,
        eventAction: this.formOpenTagging.eventAction,
        eventLabel: `${this.productInfo.productName}::${this.productInfo.productId}`,
        product_info: `${this.productInfo.productName}::${this.productInfo.productId}`
        });
      }
    },
    taggingDdx(){
      if(this.formSubmitTagging){
        window.dataLayer.push({
          event: 'uaevent',
          ecommerce: 'undefined',
          event_name: this.formSubmitTagging.event_name,
          eventCategory: this.formSubmitTagging.eventCategory,
          eventAction: this.formSubmitTagging.eventAction,
          eventLabel: this.formSubmitTagging.eventLabel,
          form_name: this.formSubmitTagging.form_name,
          product_info: `${this.productInfo.productName}::${this.productInfo.productId}`
        });
      }
    },
    showForm(){
      this.resetForm();  
      this.formEle.style.display = 'block';
      setTimeout(() => {
      window.eventBus.$emit('clearError', false);  
      },50);
      this.successContainer.style.display = 'none';
    }
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>



<style lang="scss" src="./ddx.scss"></style>


